/**
 * navigation.js
 * Mobile menu toggle + keyboard accessibility
 */

( function () {
	const toggle = document.querySelector( '.menu-toggle' );
	const nav    = document.querySelector( '.primary-nav' );

	if ( ! toggle || ! nav ) return;

	// Toggle open/close
	toggle.addEventListener( 'click', () => {
		const isOpen = nav.classList.toggle( 'is-open' );
		toggle.setAttribute( 'aria-expanded', isOpen );
		toggle.textContent = isOpen ? 'Close' : 'Menu';
	} );

	// Close on Escape
	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && nav.classList.contains( 'is-open' ) ) {
			nav.classList.remove( 'is-open' );
			toggle.setAttribute( 'aria-expanded', 'false' );
			toggle.textContent = 'Menu';
			toggle.focus();
		}
	} );

	// Close when focus leaves nav area
	nav.addEventListener( 'focusout', ( e ) => {
		if ( ! nav.contains( e.relatedTarget ) ) {
			nav.classList.remove( 'is-open' );
			toggle.setAttribute( 'aria-expanded', 'false' );
			toggle.textContent = 'Menu';
		}
	} );
} )();
